function Stages7() {
	return ( 
		<div>
			<div>
				<p>
					Im Boden lebende Tiere tragen vermehrt zur Zersetzung des Holzes bei.
				</p>
			</div>
		</div>
	 );
}

export default Stages7;